import base from "../base";
import resortBase from "../base/resort";
import logo from "./logo.svg";
import backgroundImage from "./background.jpg";
import favicon16 from "./favicon-16x16.png";
import favicon32 from "./favicon-32x32.png";
import favicon96 from "./favicon-96x96.png";
import { BrandInterface } from "../interface";

const bigBear = {
  ...base,
  ...resortBase,
  title: "Big Bear Mountain Resort",
  logo,
  backgroundImage,
  resortURL: "https://www.bigbearmountainresort.com/",
  favicons: {
    "16x16": favicon16,
    "32x32": favicon32,
    "96x96": favicon96,
  },
  color: {
    ...base.color,
    ...resortBase.color,
    header: "#000000",
    footer: "#191919",
    footerText: "#ffffff",
    button: "#D14734",
    buttonHover: "#A7392A",

    link: "#D14734",
    linkHover: "#A7392A",
  },
} as BrandInterface;

export default bigBear;
